import gql from "graphql-tag";

export const CREATE_TASK_EVENT_MUTATION = gql`
mutation createTaskEvent($data: TaskEventInput!) {
  createTaskEvent(data: $data) {
    created
    error
  }
}`